var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"big-video"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"video-wrapper"},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/ywYgEuQ9pNE?si=4aRJsE31ub0ZgxHY&start=258","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])])
}]

export { render, staticRenderFns }